import SideContainerAnimated from "../../components/SideContainer"
import SideForm from "../../components/SideForm"
import { 
    removeMaskCep, 
    removeMaskPhone, 
    removeMaskTaxpayerId 
} from "../../utils/removeMask"
import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { IFormEditClient } from "./interface"
import * as Yup from "yup";
import InputMasked from "react-input-mask";
import Person from "../../assets/icons/person.svg";
import { putBlock } from "../../service/putBlock"
import { useSelector } from "react-redux"
import { cepObject } from "../../service/cepDetail"
import { CepDetailInterface } from "../../service/interfaces/cepDetail"
import { toastCreate, toastUpdate } from "../../utils/notifications/toast"
import { translateMessageError } from "../../utils/translate/messageErrors"
import Input from "../../components/Input"
import LegendForm from "../../components/LegendForm"
import { handleCepDetailResult } from "../../utils/handleCepDetail"
import ErrorMessage from "../../components/ErrorMessage"
import Button from "../../components/Button"
import { openModal } from "../../helpers/modalFunctions"
import { initValueEditOrViewClient } from "../../utils/initialValuesForms/editOrViewClient"
import { initialSelectedClient } from "../../helpers/initialSelectedClient"
import { ContainerInputCity, ContainerInputUf, Fieldset, FlexBox } from "./style"
import ContainerFormSide from "../ContainerFormSide"

const FormEditOrViewClient = ({
    isEditFormVisible,
    isViewFormVisible,
    selectedClient,
    setIsEditFormVisible,
    setIsViewFormVisible,
    setRefresh,
    setSelectedClient
}: IFormEditClient
): React.ReactElement => {
    const login = useSelector((state: {login: any}) => state.login);
    const [cepDetail, setCepDetail] = useState<CepDetailInterface>(cepObject);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);
    const cpfLength = 11;

    const formValidationWithYup = Yup.object().shape({
        firstName: Yup.string().required(),
        lastName: Yup.string().required(),
        email: Yup.string().required(),
        phone: Yup.string().required(),
        cep: Yup.string().required(),
        city: Yup.string().required(),
        uf: Yup.string().min(2).max(2).required(),
        address: Yup.string().required(),
        district: Yup.string().required(),
        number: Yup.string().required(),
        complement: Yup.string().nullable(true),
    });

    const submitForm = async (
        values: any, 
        resetForm: Function
    ) => {
        const taxPayerId = removeMaskTaxpayerId(values.document);
        const cep = removeMaskCep(values.cep);
        let phone = removeMaskPhone(values.phone);

        const {block, isError, loading} = await putBlock(`/buyer/update/?id=${selectedClient.id}`, {
            buyerIdAdquirente: selectedClient.buyerIdAdquirente,
            buyerOwnerId: login.user.branchs.sellerOwner100PayId,
            apiOwnerId: "ZOOP",
            buyerbranchId: login.user.branchsId,
            firstName: values.firstName,
            lastName: values.lastName,
            taxpayerId: taxPayerId,
            email: values.email,
            phoneNumber: phone,
            addressLine1: values.address,
            addressLine2: values.number,
            addressLine3: values.complement,
            addressneighborhood: values.district,
            addressCity: values.city,
            addressState: values.uf,
            addressPostalCode: cep,
        });

        successSubmit(isError, resetForm)
        failSubmit(isError, block)
    }

    const successSubmit = (isError: boolean, resetForm: Function): void => {
        if(!isError) {
            resetForm({});
            setCepDetail(cepObject)
            setIsEditFormVisible("close");
            setSelectedClient(initialSelectedClient);
            toastUpdate("btnSubmit", "success", 3000, "Sucesso")
            setRefresh(true)
            openModal("exampleModal");
        } 
    }

    const failSubmit = (isError: boolean, block: any): void => {
        if(isError) {
            let msg = null

            msg = translateMessageError(
                block.error.message.replaceAll(/\"/g, "'")
            )
            setErrorOnReturnApi(true);
            toastUpdate(
                "btnSubmit",
                "error",
                4000, 
                msg ?? "Houve um problema ao criar esse cliente. Contate o suporte."
            )
        }
    }

    return (
        <SideContainerAnimated isVisible={isEditFormVisible || isViewFormVisible}>
            <SideForm
                title={isEditFormVisible ? "Editar Cliente" : "Visualizar Cliente"}
                icon={Person}
                visible={() => {
                    isEditFormVisible && setIsEditFormVisible("close")
                    isViewFormVisible && setIsViewFormVisible("close")
                    setCepDetail(cepObject)
                }}
            >
                <Formik
                    initialValues={initValueEditOrViewClient}
                    validationSchema={formValidationWithYup}
                    onSubmit={async (values, {resetForm}) => {
                        await submitForm(values, resetForm)
                    }}
                >
                    {({ initialValues, values, handleChange, errors }) => {
                        initialValues.firstName = selectedClient.firstName || "";
                        initialValues.lastName = selectedClient.lastName || "";
                        initialValues.email = selectedClient.email || "";
                        initialValues.phone = selectedClient.phoneNumber || "";
                        initialValues.document = selectedClient.taxpayerId || "";
                        initialValues.cep = selectedClient.addressPostalCode || "";
                        initialValues.number = selectedClient.addressLine2 || "";
                        initialValues.complement = selectedClient.addressLine3 || "";

                        if(selectedClient.addressPostalCode !== null) {
                            initialValues.city = selectedClient.addressCity || "";
                            initialValues.uf = selectedClient.addressState || "";
                            initialValues.address = selectedClient.addressLine1 || "";
                            initialValues.district = selectedClient.addressneighborhood || "";
                        }

                        if(selectedClient.addressPostalCode === null){
                            values.city = cepDetail.localidade;
                            values.uf = cepDetail.uf;
                            values.district = cepDetail.bairro;
                            values.address = cepDetail.logradouro;
                        }
                        
                        return(
                            <ContainerFormSide>
                                <Form>
                                    <Fieldset>
                                        <LegendForm>Dados Principais</LegendForm>
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="firstName" 
                                            name="firstName" 
                                            className="inputCustom" 
                                            placeholder="Primeiro Nome" 
                                            as={Input}
                                        />
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="lastName" 
                                            name="lastName" 
                                            className="inputCustom" 
                                            placeholder="Último Nome" 
                                            as={Input}
                                        />
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="email" 
                                            name="email" 
                                            className="inputCustom" 
                                            placeholder="Email" 
                                            as={Input}
                                        />
                                        <Field
                                            disabled={isViewFormVisible}
                                            name="phone"
                                            id="phone"
                                            value={values.phone}
                                            className="input-masked inputCustom" 
                                            placeholder="Telefone" 
                                            onChange={handleChange}
                                            mask="(99) 99999-9999"
                                            maskChar={null}
                                            as={InputMasked}
                                        />
                                        <Field
                                            disabled={isViewFormVisible}
                                            name="document" 
                                            id="document" 
                                            value={values.document}
                                            className="input-masked inputCustom" 
                                            placeholder={
                                                initialValues.document.length === cpfLength 
                                                    ? "CPF" 
                                                    : "CNPJ"
                                            }
                                            mask={
                                                initialValues.document.length === cpfLength 
                                                    ? "999.999.999-99" 
                                                    : "99.999.999/9999-99"
                                            }
                                            onChange={handleChange}
                                            maskChar={null}
                                            as={InputMasked}
                                        />
                                    </Fieldset>
                                    <Fieldset>
                                        <LegendForm>Endereço</LegendForm>
                                        <Field 
                                            disabled={isViewFormVisible}
                                            name="cep" 
                                            id="cep" 
                                            value={values.cep}
                                            className="input-masked inputCustom" 
                                            placeholder="CEP"
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                handleChange(e)
                                            }}
                                            onKeyUp={async () => {
                                                if(isEditFormVisible) {
                                                    if(values.cep.length === 9){
                                                        await handleCepDetailResult(values.cep, setCepDetail);
                                                        
                                                    }
                                                }
                                            }}
                                            mask="99999-999"
                                            maskChar={null}
                                            as={InputMasked}
                                        />
                                        <FlexBox>
                                            <ContainerInputCity>
                                                <Field 
                                                    disabled={isViewFormVisible} 
                                                    id="city" 
                                                    name="city" 
                                                    value={values.city}
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                                        handleChange(e);
                                                        setCepDetail({...cepDetail, localidade: e.target.value})
                                                    }}
                                                    className="inputCustom" 
                                                    placeholder="Cidade" 
                                                    as={Input}
                                                />
                                            </ContainerInputCity>
                                            <ContainerInputUf>
                                                <Field
                                                    disabled={isViewFormVisible}
                                                    name="uf" 
                                                    id="uf" 
                                                    className="input-masked inputCustom" 
                                                    placeholder="UF"
                                                    onChange={handleChange}
                                                    mask="aa"
                                                    maskChar={null}
                                                    as={InputMasked}
                                                />
                                            </ContainerInputUf>
                                        </FlexBox>
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="address" 
                                            name="address" 
                                            className="inputCustom" 
                                            placeholder="Endereço" 
                                            as={Input}
                                        />
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="district" 
                                            name="district" 
                                            className="inputCustom" 
                                            placeholder="Bairro" 
                                            as={Input}
                                        />
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="number" 
                                            name="number" 
                                            className="inputCustom" 
                                            placeholder="Número" 
                                            as={Input}
                                        />
                                        <Field 
                                            disabled={isViewFormVisible} 
                                            id="complement" 
                                            name="complement" 
                                            className="inputCustom" 
                                            placeholder="Complemento" 
                                            as={Input}
                                        />
                                    </Fieldset>

                                    { errorOnReturnApi
                                        ? <ErrorMessage>
                                            Erro ao cadastrar cliente
                                        </ErrorMessage>
                                        : null
                                    }

                                    {
                                        isEditFormVisible 
                                        && <Button
                                            type="submit"
                                            className="buttonCustom"
                                            onClick={() => {
                                            toastCreate("btnSubmit", "info", 3000, "Processando")
                                        }}>
                                            Salvar
                                        </Button>
                                    }
                                </Form>
                            </ContainerFormSide>
                        )  
                    }}
                    </Formik>
                </SideForm>
            </SideContainerAnimated>
    )
}

export default FormEditOrViewClient